import { useEffect } from 'react';
import { PageLoader } from '@commerce-webcomponents/ui';
import { useSelector } from 'react-redux';
import { type AppState } from '@nextgen-web-framework/core';
import { RegistrationInviteStepProps } from './types/propTypes';
import styles from './RegistrationInviteStep.module.scss';

const RegistrationInviteStep = ({ nextHandler }: RegistrationInviteStepProps) => {
  const registrationFlowData = useSelector((state: AppState) => state.commerceProfile.registrationFlowData);
  const patchVersion = registrationFlowData?.userData?.patchVersion;

  useEffect(() => {
    nextHandler({ version: patchVersion }, undefined, false, false);
  }, []);

  return (
    <div className={styles['registration-loading-container']} data-testid="registration-loading-container">
      <PageLoader />
    </div>
  );
};
export default RegistrationInviteStep;
